var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumbnail",style:({ width: (_vm.size + "px"), height: (_vm.size + "px") }),on:{"click":function($event){$event.stopPropagation();return _vm.handleClick($event)}}},[_c('canvas',{ref:"canvas",attrs:{"width":_vm.size,"height":_vm.size}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47cdece7","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Logic/5Five/SamplesPreview/Thumbnail.vue
// module id = null
// module chunks = 